var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHospital(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m13.5 197.835h145v260h-145z",
    fill: "#00b3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 182.835h158.5v30h-158.5z",
    fill: "#5f7883"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m143.5 126.005h355v331.83h-355z",
    fill: "#f0f7ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m321 126.005h177.5v331.83h-177.5z",
    fill: "#d7e9fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130 111.005h382v30h-382z",
    fill: "#5f7883"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m321 111.005h191v30h-191z",
    fill: "#4b5055"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#f0f7ff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m78.5 247.835h30v30h-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.5 312.835h30v30h-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.5 377.835h30v30h-30z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m338.5 312.835h30v30h-30z",
    fill: "#3a80e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m403.5 312.835h30v30h-30z",
    fill: "#3a80e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m273.5 312.835h30v30h-30z",
    fill: "#00b3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208.5 312.835h30v30h-30z",
    fill: "#00b3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m403.5 247.835h30v30h-30z",
    fill: "#3a80e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m338.5 247.835h30v30h-30z",
    fill: "#3a80e8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m227.3 39.165v173.67h187.4v-173.67z",
    fill: "#ff5f7b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m321 39.165h93.7v173.67h-93.7z",
    fill: "#ea344a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m365.07 111.005v30h-29.07v29.07h-30v-29.07h-29.07v-30h29.07v-29.07h30v29.07z",
    fill: "#f0f7ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m365.07 111.005v30h-29.07v29.07h-15v-88.14h15v29.07z",
    fill: "#d7e9fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m273.5 247.835h30v30h-30z",
    fill: "#00b3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208.5 247.835h30v30h-30z",
    fill: "#00b3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m257.25 377.835h127.5v80h-127.5z",
    fill: "#5fd6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m321 377.835h63.75v80h-63.75z",
    fill: "#00b3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 442.835h512v30h-512z",
    fill: "#bde760"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 442.835h256v30h-256z",
    fill: "#00d880"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospital);
export default __webpack_public_path__ + "static/media/hospital.a157b9a82c30f23de8160382b9d43173.svg";
export { ForwardRef as ReactComponent };